export const heroSection = {
    title: "Welcome to HeyBO!",
    description: "The AI Connecting You to Local Stores in Real Time",
    buttonTitle: "Ask HeyBO"
};

export const shopByBrandSection = {
    title: "Shop by brand",
    description: `Buy products from your favorite brands, directly from physical stores enrolled in HeyBO.
                  <br />
                  Simply select a product on an image, share your location and get the best store to buy from!`,
    buttonTitle: "Suggest a brand"
};

export const shopByStoreSection = {
    title: "Shop by store",
    description: `You have a favorite store? Just select the store.
                <br />
                Then share your location and HeyBO will show products from that store!`,
    buttonTitle: "Suggest a store"
};

export const newestSection = {
    title: "Shop by item",
    description: `The most direct and fun way to get the product you want, supporting physical stores around you.
                <br />
                Select the image, select the product, share your location and HeyBO will take you to a store!`,
    buttonTitle: "Suggest a brand"
};

export const physicalStoresSection = {
    title: "HeyBO stores map",
    description: "Many stores and more to come!",
    buttonTitle: "Suggest a store"
};
